import { QuestionnaireStatus } from '@/components/decision-tree';
import RiskAssessmentBanner from '@/components/risk-assessment-banner/risk-assessment-banner';
import useIsMobile from '@/hooks/use-is-mobile';
import { Box, Divider, Flex } from '@cmpsr/components';
import React from 'react';
import RiskAssessmentSections from './components/risk-assessment-sections/risk-assessment-sections';
import DashboardGrid from '@/components/dashboard/dashboard-grid/dashboard-grid';

type RiskAssessmentTabProps = {
  assessmentProgress: number;
  questionnaireStatus: QuestionnaireStatus;
  iDontKnowAnswers: number;
  totalAnsweredQuestions: number;
};

function RiskAssessmentTab({
  assessmentProgress,
  questionnaireStatus,
  iDontKnowAnswers,
  totalAnsweredQuestions,
}: RiskAssessmentTabProps) {
  const isMobile = useIsMobile();

  return (
    <DashboardGrid
      pt={{ base: 5, md: 8, lg: 12 }}
      gap={{ base: 4, lg: 8, xl: 9, xxl: 12 }}
      gridTemplateAreas={{
        base: `"aside"
              "main"`,
        lg: `"main aside"`,
      }}
    >
      <Box gridArea="main">
        <RiskAssessmentSections questionnaireStatus={questionnaireStatus} />
      </Box>
      <Flex direction="column" gap="spacer-4" gridArea="aside">
        <RiskAssessmentBanner
          questionnaireStatus={questionnaireStatus}
          variant="large"
          assessmentProgress={assessmentProgress}
          text={`You skipped ${iDontKnowAnswers}/${totalAnsweredQuestions} questions. Refine
          your answers to get the most accurate risk assessment.`}
        />
        {isMobile && <Divider />}
      </Flex>
    </DashboardGrid>
  );
}

export default React.memo(RiskAssessmentTab);
